import './_vendor';
import vars from './_vars';
import './_functions';
import './_components';

const swiper = new Swiper('.main_swiper', {

  loop: true,
  autoplay: {
    delay: 10000,
    disableOnInteraction: false,
  },

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next_c',
    prevEl: '.swiper-button-prev_c',
  },

});
